import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../../../store';
import { isLeadFactory } from '../../../../utils/agent';

import { openFeedbackPopup } from '../../../actions/feedback';
import { TextWithLink } from './TextWithLink';

export function mapStateToProps(state: IState) {
  return {
    isLeadFactory: isLeadFactory(state.offerData.offer),
    showWarningMessage: state.offerData.offer.showWarningMessage,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<{}>) {
  return {
    onClick() {
      dispatch(openFeedbackPopup());
    },
  };
}

export const TextWithLinkContainer = connect(mapStateToProps, mapDispatchToProps)(TextWithLink);
